import React, { useState } from "react";
import classes from "./RowOptionsOverlay.scss";
import { Dialog, IconButton, Tooltip } from "@toddle-edu/ds-web";
import { AddRowOutlined, DeleteOutlined } from "@toddle-edu/ds-icons";
import { elevations } from "@toddle-edu/ds-theme";
import PropTypes from "prop-types";

// component to add rows to left or right, or delete rows.
const RowOptionsOverlay = React.memo(
  ({ deleteRow, id, index, addRow, t, testId }) => {
    const addRowBefore = () => addRow(index);
    const addRowAfter = () => addRow(index + 1);
    const deleteRowIndex = () => deleteRow(id);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const toggleDeleteDialog = () => {
      setShowDeleteDialog(!showDeleteDialog);
    };

    return (
      <div className={classes.container} style={elevations["elevation-2B"]}>
        <Tooltip tooltip={t("project:add_row_below")}>
          <IconButton
            icon={<AddRowOutlined />}
            type="plain"
            variant="neutral"
            onMouseDown={addRowAfter}
            size="small"
            testId={`${testId}-RowOptionsOverlay-AddRowAfter`}
          ></IconButton>
        </Tooltip>
        <Tooltip tooltip={t("project:add_row_above")}>
          <IconButton
            icon={<AddRowOutlined />}
            type="plain"
            variant="neutral"
            // same icon rotated 180deg
            className={classes.reverseX}
            onMouseDown={addRowBefore}
            size="small"
            testId={`${testId}-RowOptionsOverlay-AddRowBefore`}
          ></IconButton>
        </Tooltip>
        <div className={classes.divider} />
        <Tooltip tooltip={t("project:delete_row")}>
          <IconButton
            icon={<DeleteOutlined />}
            type="plain"
            variant="neutral"
            onMouseDown={toggleDeleteDialog}
            size="small"
            testId={`${testId}-RowOptionsOverlay-DeleteRow`}
          ></IconButton>
        </Tooltip>
        {showDeleteDialog ? (
          <Dialog
            title={t("common:delete_with_label", {
              label: t(`common:row`),
            })}
            message={t("project:delete_warning_with_label", {
              label: t(`common:row`),
            })}
            buttonOneText={t("common:cancel")}
            buttonTwoText={t("common:delete")}
            onButtonOneClick={toggleDeleteDialog}
            onButtonTwoClick={deleteRowIndex}
            isClosable={true}
            onClose={toggleDeleteDialog}
            testId={`${testId}-RowOptionsOverlay-DeleteDialog`}
            dsVersion="2.0"
          />
        ) : null}
      </div>
    );
  }
);

RowOptionsOverlay.displayName = "RowOptionsOverlay";

RowOptionsOverlay.propTypes = {
  deleteRow: PropTypes.func,
  addRow: PropTypes.func,
  index: PropTypes.number,
  testId: PropTypes.string,
};
export default RowOptionsOverlay;
